import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'moi-risk-summary',
    templateUrl: './moi-risk-summary.component.html',
    styleUrls: ['./moi-risk-summary.component.scss'],
    standalone: false,
    providers: [provideTranslocoScope('moi')],
})
export class MoiRiskSummaryComponent {
  private tabservice = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() riskGuid: any;

  openRisk() {
      if (!this.riskGuid || !this.summaryModel.CanOpenParent) {
          return;
      }

      this.tabservice.generateTab(this.pages.RiskDetail, this.riskGuid);
  }
}
